import logo from "../../assets/livingpp-logo.svg";

type Props = {
  width?: number;
  height?: number;
};

export const Logo: React.FC<Props> = ({ width, height }) => {
  return <img src={logo} width={width} height={height} alt="logo" />;
};
